import React from "react";
import backgroundimg from "./../image/banner.png";
import { Helmet } from "react-helmet";

const Privacy = () => {
    return (
    <div className="w-full mx-w-[1400px] h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">
    <Helmet>
        <title>Privacy Policy - Nexify InfoSystems</title>
        <meta
          name="description"
          content="Learn how Nexify InfoSystems collects, uses, and protects your personal information in accordance with our privacy policy."
        />
        <meta
          name="keywords"
          content="Nexify, Privacy Policy, data protection, user privacy, personal data, security, terms"
        />
      </Helmet>
        {/* Header Section */}
        <div
    className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
    style={{ backgroundImage: `url(${backgroundimg})` }}
  >
    <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
      <div
        className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
        style={{
          animation: "slideUp 1s ease-in-out forwards",
          animationDelay: "2s",
        }}
      >
        {/* 🔵 Dot Pattern Overlay Inside Box */}
        <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>
  
        <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2 break-words">
              Privacy Policy
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
              Your data, our priority at Nexify InfoSystems
            </h2>
  
            </div>
          </div>
        </div>
  
         
            {/* Policy Content */}
            <div className="bg-white flex flex-col items-start text-left px-6 md:px-10 lg:px-20 w-full max-w-[1200px] mt-10 gap-6 mb-20 text-[#333]">
                <h2 className="lg:text-[40px] text-2xl font-semibold text-[#005eb8]">
                    Nexify InfoSystems Privacy Policy
                </h2>

                <div className="space-y-4 leading-relaxed text-[17px]">
                    <h3 className="text-xl font-semibold">Introduction</h3>
                    <p>
                        Nexify InfoSystems ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and protect your personal information when you visit our website,<a href=""  className="text-blue-600 underline">www.nexifyinfosystems.com</a> , and use our services.
                    </p>
                    <p>
                        By using our website, you agree to the collection and use of information in accordance with this Privacy Policy.
                    </p>

                    <h3 className="text-xl font-semibold">Information We Collect</h3>
                    <p>
                        We collect various types of information when you visit our website, including:
                    </p>
                    <ul className="list-disc pl-6">
                        <li>
                            <strong>Personal Information:</strong> When you interact with us through forms, emails, or other communications, we may collect personal data, such as your name, email address, phone number, and other contact details.
                        </li>
                        <li>
                            <strong>Automated Data Collection:</strong> We use cookies and similar technologies to collect data about your interactions with our website. This can include your IP address, browser type, operating system, referring URLs, and your activity on the website.
                        </li>
                    </ul>

                    <h3 className="text-xl font-semibold text-gray-800 mb-2">How We Use Your Information</h3>
                    <p className="text-gray-700 mb-2">We use the information we collect for several purposes, including:</p>
                    <ul className="list-disc pl-6">
                        <li>To provide, maintain, and improve our services.</li>
                        <li>To respond to your inquiries and requests.</li>
                        <li>To send you updates, newsletters, or other communications that may interest you, based on your preferences.</li>
                        <li>To monitor and analyze website usage to improve user experience.</li>
                        <li>For recruitment purposes.</li>
                    </ul>

                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Information Sharing</h3>
                    <p className="text-gray-700 mb-2">We may share your information in the following circumstances:</p>
                    <ul className="list-disc pl-6">
                        <li>With third-party service providers that help us with website hosting, customer service, or data analytics.</li>
                        <li>With our partners, such as Flexton, E-Solutions, Randstad, Indotronix, and Apex Systems, to deliver services as part of our business operations.</li>
                        <li>As required by law or to protect our rights.</li>
                    </ul>
                    <p>We will not sell, rent, or lease your personal information to third parties.</p>

                    <h3 className="text-xl font-semibold">Security of Your Information</h3>
                    <p>
                        We take reasonable steps to protect the personal information you provide to us, including using secure servers and encryption. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee its absolute security.
                    </p>

                    <h3 className="text-xl font-semibold">Your Rights</h3>
                    <p>
                        You have the right to access, correct, update, or delete your personal information. To exercise your rights or if you have any concerns, please contact us at <a href="mailto:info@nexifyinfosystems.com" className="text-blue-600 underline">info@nexifyinfosystems.com</a>.
                    </p>

                    <h3 className="text-xl font-semibold">Cookies and Tracking Technologies</h3>
                    <p>
                        We use cookies and similar tracking technologies to enhance your experience on our website. For more information about how we use cookies, please refer to our Cookie Policy.
                    </p>

                    <h3 className="text-xl font-semibold">International Transfers</h3>
                    <p>
                    Your information may be transferred to and maintained on computers located outside your country. By using our website, you consent to this transfer.
                    </p>

                    <h3 className="text-xl font-semibold">Changes to This Privacy Policy</h3>
                    <p>
                    We may update this Privacy Policy from time to time. When we make significant changes, we will notify you by posting a prominent notice on our website.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
